import appStarterFactory from 'bundles/page/lib/appStarterFactory';
import appEnv from 'bundles/program-skills-objectives/appEnv';

export default appStarterFactory(appEnv);
